export default __webpack_public_path__ + "static/media/success_file.9926e0f9.svg";